import { createContext, useState, type ReactNode } from "react";

interface MenuContextType {
  menuOpen: boolean;
  toggleMenu: () => void;
  setMenuOpen: (menuOpen: boolean) => void;
}

const MenuContext = createContext<MenuContextType>({} as MenuContextType);

export const MenuProvider: React.FC<{
  children: ReactNode;
  lastSelectedVenue?: number | string;
}> = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <MenuContext.Provider
      value={{
        menuOpen,
        toggleMenu,
        setMenuOpen,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export const MenuConsumer = MenuContext.Consumer;

export default MenuContext;
